import { z } from 'zod'

const optionalText = () => z.string().trim().max(200).optional()
const optionalUrl = () => z.string().trim().url().optional()

export const submissionHoneypotField = 'companyWebsite'
export const submissionStartedAtField = 'startedAt'

const baseSubmissionSchema = z.object({
  honeypot: z.string().max(0).default(''),
  startedAt: z.string().optional().default(''),
})

export const contactSubmissionSchema = baseSubmissionSchema.extend({
  name: z.string().trim().min(2, 'Please enter your name.').max(120),
  email: z.string().trim().email('Please enter a valid email address.'),
  company: optionalText(),
  topic: z.enum(['general', 'sales', 'support', 'partnership']),
  budget: z.enum(['under-10k', '10k-25k', '25k-50k', '50k-plus', 'unsure']).optional(),
  message: z.string().trim().min(20, 'Please add a little more detail.').max(4000),
  newsletterOptIn: z.boolean().default(false),
  source: z.string().trim().min(1).default('contact-page'),
})

export const newsletterSubscriptionSchema = baseSubmissionSchema.extend({
  email: z.string().trim().email('Please enter a valid email address.'),
  source: z.string().trim().min(1).default('footer'),
})

export const jobApplicationSchema = baseSubmissionSchema.extend({
  name: z.string().trim().min(2, 'Please enter your name.').max(120),
  email: z.string().trim().email('Please enter a valid email address.'),
  role: z.enum(['frontend', 'designer', 'product', 'operations', 'other']),
  portfolio: optionalUrl(),
  linkedin: optionalUrl(),
  message: z.string().trim().min(40, 'Tell us a little more about your background.').max(5000),
  source: z.string().trim().min(1).default('careers-apply'),
})

export type ContactSubmissionInput = z.input<typeof contactSubmissionSchema>
export type NewsletterSubscriptionInput = z.input<typeof newsletterSubscriptionSchema>
export type JobApplicationInput = z.input<typeof jobApplicationSchema>
